import React from "react";
import {tabOptionService} from "../jwt/_services/promotions/tabOptionService";

export const tabOptionProvider = {
    getOptions,
    getItem,
};

async function getOptions(){
    try {
        const listItems = await tabOptionService.search(0, 100, null);

        return listItems.data.sort((a, b) => a?.showOrder - b?.showOrder ).map((itemData) => {
            const { id, code } = itemData
            let show = code != null && code !== "" ? code : "Sin codigo";
            return (
                {
                    id: id,
                    value: show,
                    label: <div><label>{show}</label></div>
                }
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}

async function getItem(id){
    try {
        const item = await tabOptionService.getItem(id);
        let show = item.code != null && item.code !== "" ? item.code : "Sin codigo";
        return (
            {
                id: item.id,
                value: show,
                label: <div><label>{show}</label></div>
            }
        );
    } catch (error) {
        console.log(error.message)
    }
}